  <div class="modal-header">
    <h4 
       [ngClass]="{'modal-title text-primary': datAviso.tip === 0, 'modal-title text-warning': datAviso.tip === 1,'modal-title text-danger': datAviso.tip === 2 }"
       id="modal-title">{{datAviso.tit}}
    </h4>
    <button type="button" class="close" aria-describedby="modal-title"(click)="saleCAN()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
      <p [ngClass]="{'text-primary': datAviso.tip === 0, 'text-warning': datAviso.tip === 1,'text-danger': datAviso.tip === 2 }" >
         {{datAviso.tex}}
      </p>
  </div>
  <div class="modal-footer">
    <button  [hidden]="swCan" type="button" class="btn btn-outline-secondary" (click)="saleCAN()">{{datAviso.btcan}}</button>
    <button  [hidden]="swNo" type="button" class="btn btn-outline-secondary" (click)="saleNO()"> {{datAviso.btno}}</button>
    <button type="button" class="btn btn-primary" (click)="saleSI()"> {{datAviso.btsi}} </button>
  </div>


  